import { css } from 'lit';

export const vesselOwnRouteReasonPopupStyles = [
    css`
        .input-space {
            margin-bottom: 1.25rem;
        }

        #alarm-popup .popup {
            width: 25rem;
            max-width: 80vw;
            height: 2.5rem;
            padding: 0 1.5rem;
        }

        #success-topContainer {
            padding: 1.5rem;
            width: 24.5rem;
            display: grid;
            align-items: center;
            justify-items: start;
            column-gap: 0.9375rem;
            row-gap: 1rem;
            border-bottom: 0.0625rem solid var(--neutrals-grey-07);
        }

        .success-innerContainer {
            display: flex;
            background-color: #c5e5c2;
            padding: 1.25rem;
            border-radius: 0.375rem;
        }

        .content {
            margin-left: 1.25rem;
        }

        .desc {
            color: var(--neutrals-grey-02, grey);
            font-size: 0.875rem;
            line-height: 1.25rem;
            margin-bottom: 0.625rem;
        }
        
        #alarm-popup #footer {
            display: flex;
            justify-content: flex-end;
            padding: 0.75rem;
            background: #f7f7f7;
        }

        #alarm-popup #footer button {
            height: 2.1875rem;
            min-width: 5rem;
            font-size: 0.875rem;
            font-family: MaerskText;
            background: none;
            border: none;
            outline: none;
            cursor: pointer;
            border-radius: 0.1875rem;
            width: auto;
        }

        #alarm-popup #footer .do-it-later-button {
            color: var(--neutrals-grey-02);
            margin-right: 1.25rem;
            border: 1px solid var(--neutrals-grey-06, grey);
            display: flex;
            line-height: 1.75rem;
        }

        #alarm-popup #footer .submit-button {
            margin-right: 1.25rem;
            border-radius: 0.375rem;
        }

        .comment-input > textarea {
            white-space: normal;
            padding-left: 0.625rem;
            font-family: MaerskText;
        }

        .footer {
            text-align: end;
            padding: 1rem 1.5rem;
            margin: -1.5rem;
            margin-top: 1.25rem;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            padding: 1rem 1.5rem;
            gap: 0.75rem;
            height: 4rem;
            background: #f7f7f7;
            border-bottom-left-radius: 0.375rem;
            border-bottom-right-radius: 0.375rem;
        }

        .clf-date {
            display: flex;
        }

        .inputAndHeader {
                display: flex;
                flex: 1;
                flex-direction: column;
                font-size: 14px;
                padding-bottom: 1.5rem;
        }

        .inputContainer {
                display: flex;
                align-items: center;
                box-sizing: border-box;
                height: 52px;
                border: 1px solid var(--neutrals-grey-06);
                background-color: var(--neutrals-grey-10, white);
                border-radius: 3px;
        }

        input[type="datetime-local"]{
                font-family: var(--component-paragraph-ff, serif);
                font-size: 14px;
                box-sizing: border-box;
                width: 100%;
                padding-left: 10px;
                padding-right: 10px;
                border: none;
                outline: none;
                color: var(--neutrals-grey-02);
                background-color: unset;
        }

        .error-message {
            color: #B80012;
            font-size: 14px;
            margin-top: 4px;
            display: block;
        }
        
        .inputContainer.invalid {
            border: 1px solid #B80012;
        }

        .footer-clf{
            text-align: end;
            padding: 1rem 1.5rem;
            margin: -1.5rem;
            margin-top: 1.25rem;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            padding: 1rem 1.5rem;
            gap: 0.75rem;
            background: #f7f7f7;
            border-bottom-left-radius: 0.375rem;
            border-bottom-right-radius: 0.375rem;
        }

          .eta-header {
            margin-top: 8px;
            font-size: 16px;
        }

        .eta {
            margin-top: 4px;
            font-size: 0.8rem;
            margin-bottom: 1.2rem;
        }

        .eta-label {
            color: #002b45; 
        }

        .eta-value {
            font-weight: 600;
            color: #002b45;
        }
        .infoContanier {
            display: flex;
            flex-direction: row;
            align-items: top;
            justify-content: center;
            height: 100%;
            border-top: 1px solid var(--neutrals-grey-07, grey);
        }    
        .infoContanier.offlinePlan {
            width: 100%;
            padding: 20px 0;
        }
        .infoContanier.basicPlan {
            padding: 20px;
        }    
        .infoContanier.offlinePlan .icon .network-status-icon svg {
        width: 27px;
            height: 27px;
            color: #b80012;
            margin: 0 20px 0 0;
        }
        .infoContanier.offlinePlan .text .offlineText, .infoContanier.basicPlan .text .basicText {
            color:#997303;
            font-size: 13px;
        }
        .infoContanier.offlinePlan .text .syncText {
            color: #545454;
            margin-top: 5px;
            font-size: 13px;
        }    
    `,
];